import { api } from "./api";


export async function getAttendant(id: number) {
  return await api.get(`/attendant/${id}`);
}

export async function getAttendants() {
  return await api.get(`/attendant/list`);
}

export async function createAttendant(userId: string) {
  return await api.post(`/attendant/userId`, { userId });
}

export const getAttendantByUserId = async (userId: string) => {
  return api.post(`/attendant/userId`, { userId });
};



const attendantApi = {
  getAttendant,
  createAttendant,
  getAttendants,
  getAttendantByUserId
};

export default attendantApi;
